export class RoleModel {
  name: string;
  permission: any[];

  constructor(){
    this.name = "";
    this.permission = [];
  }
}
